import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Plane, MapPin, Car, ArrowLeftRight, Briefcase, RefreshCw } from 'lucide-react';

const services = [
  { icon: Plane, title: 'Airport Pickup & Drop', trip: 'airport_transfer' },
  { icon: MapPin, title: 'Outstation Trips', trip: 'round_trip' },
  { icon: Car, title: 'Local Taxi', trip: 'local_rental' },
  { icon: ArrowLeftRight, title: 'One-Way Taxi', trip: 'one_way' },
  { icon: Briefcase, title: 'Corporate Travel', trip: 'one_way' },
  { icon: RefreshCw, title: 'Round Trip Cab', trip: 'round_trip' },
];

const AtithiServicesSection = () => {
  const navigate = useNavigate();

  return (
    <section
      id="services"
      className="section-outer section-standard font-body mb-0"
      style={{ background: '#1B2D5E', borderTop: '3px solid #E8651A' }}
    >
      <div className="section-inner section-inner--services">
        <div className="flex flex-wrap items-center justify-between gap-4 mb-10">
          <h2 className="font-display text-white" style={{ fontSize: '36px' }}>
            Our Services
          </h2>
          <button
            type="button"
            onClick={() => navigate('/book-vehicle')}
            className="font-body hover:underline"
            style={{ color: '#E8651A', fontSize: '13px' }}
          >
            View All Services →
          </button>
        </div>

        <div className="grid-services-3">
          {services.map(({ icon: Icon, title, trip }) => (
            <button
              key={title}
              type="button"
              onClick={() => navigate(`/book-vehicle?trip=${trip}`)}
              className="group flex items-center justify-between gap-4 w-full text-left border border-white/10 rounded-[10px] px-5 py-4 bg-white/5 hover:bg-white/10 hover:border-[#E8651A]/30 transition-all duration-200 cursor-pointer"
            >
              <div className="flex items-center gap-4 min-w-0">
                <Icon size={24} className="text-[#E8651A] shrink-0" />
                <span className="font-body text-white font-semibold text-[15px]">{title}</span>
              </div>
              <span className="text-white/40 text-sm group-hover:text-[#E8651A] transition-colors shrink-0">→</span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AtithiServicesSection;
